import 'angular';

function ResourceRenameModalCtrl($scope, FileOrFolder, ClientMetricsService, FileService, MessageProvider) {
     
     $scope.formData = {
         resourceName: FileOrFolder.VersionMetadata ? FileOrFolder.VersionMetadata.Name : FileOrFolder.Name
     };

     $scope.viewData = {};
     
     $scope.renameFolder = () => {        
        FileService.updateName(FileOrFolder, $scope.formData.resourceName)
        .then(() => {
            $scope.$close(true);
        });
     };
}

ResourceRenameModalCtrl.$inject = ['$scope', 'FileOrFolder', 'ClientMetricsService', 'FileService', 'MessageProvider'];

angular.module('GorillaBoy.services')
.run(['$templateCache', ($templateCache) => {
    $templateCache.put('./shared/rename_modal.html', `
        <div class="modal-header">
            <button type="button" class="close" ng-click="$dismiss();"></button>
            <h3 translate>MODAL.RENAME_FOLDER_MODAL.RENAME_FOLDER</h3>
        </div>
        <div class="modal-body">
            <p>
                <translate>MODAL.RENAME_FOLDER_MODAL.ENTER_FOLDER_NAME</translate>:
            </p>
            <form name="form" ng-submit="renameFolder()" class="modal-full-width">
                <input type="text" 
                    style="display: block;width: 100%;border-radius: 5px;padding: 5px;margin: 10px 0px;"
                    ng-attr-placeholder="{{'MODAL.RENAME_FOLDER_MODAL.FOLDER_NAME' | translate}}" 
                    ng-model="formData.resourceName" 
                    name="resourceName" 
                    required autofocus/>
            </form>
        </div>
        <div class="modal-footer">
            <a class="btn btn-primary btn-create" ng-click="renameFolder()" translate>MODAL.RENAME_FOLDER_MODAL.RENAME_IT</a>
        </div>
    `);
}])
.controller('ResourceRenameModalCtrl', ResourceRenameModalCtrl);
